import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import {
  AssortmentTypes,
  CalculusArea,
  ConditionFilterOptionsDTO,
  ConditionState,
} from '@retail/calculus/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

export interface ConditionFiltersParams extends QueryOptions {
  assortmentId: number;
  conditionType?: CalculusArea;
  supplierNumber?: number;
  conditionState?: ConditionState;
  assortmentType?: AssortmentTypes;
}

export function useFetchConditionFilterOptions({
  assortmentId,
  conditionType,
  supplierNumber,
  conditionState,
  assortmentType,
  ...queryOptions
}: ConditionFiltersParams) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<ConditionFilterOptionsDTO>({
    method: 'GET',
    queryKey: [
      'condtition-filters',
      assortmentId,
      conditionType,
      supplierNumber,
      conditionState,
      assortmentType,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortments.assortment.conditions.filters.getFullLinkPath({ assortmentId }),
      searchParams: {
        conditionType,
        supplierNumber,
        conditionState,
        assortmentType,
      },
    }),
    ...queryOptions,
  });
}
